import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { selectCurrentInstitute, selectUserData } from "../components/widgets/exHeader/userSlice";
import { selectProductData } from "../components/pages/pdp/productSlice";
import { formatPendoObjectForUser, isUserConsentToAnalytics } from "../components/util/userUtil";
import { selectSubject } from "../components/widgets/subject/subjectSlice";

export const usePendo = () => {
    const [isInit, setIsInit] = useState(false);
    const userData = useSelector(selectUserData);
    const currentInstitute = useSelector(selectCurrentInstitute);
    const productData = useSelector(selectProductData);
    const subject = useSelector(selectSubject);
    const userConsent = isUserConsentToAnalytics();
    const [initConsent, setIsInitConsent] = useState(userConsent)

    useEffect(() => {
      if (window?.pendo) {
        const { initialize, updateOptions, clearSession, teardown } = window?.pendo;
        const isConsentChanged = initConsent !== userConsent;
        const action = !isInit ? initialize : updateOptions;
        if(!window?.piSession?.userId()) {
          clearSession();
          window?.localStorage.clear();
        }
        if (!isInit){
          clearSession(); //clean any local cookies before init
        }
        const { account, visitor, analytics } = formatPendoObjectForUser(
          userData,
          currentInstitute,
          productData,
          subject
        ) ?? {};
        if (isConsentChanged) {
          clearSession();
          teardown();
          initialize({ account, visitor, analytics });
          setIsInitConsent(userConsent);
          return;
        }
        action?.({ account, visitor, analytics });
        setIsInit(true)
      }
    }, [window?.pendo, window?.piSession, currentInstitute, productData, userData, subject, document.cookie, userConsent])
}